<template>
  <div>
    <helper-layout :loaded="mx_loaded">
      <material-table
        :headers="headers"
        :paginate="paginateConfig"
        :items="customerLevelData.items"
        :total-count="customerLevelData.totalCount"
        :has-paginate="false"
      >
        <template v-slot:toolbar>
          <v-layout justify-space-between>
            <v-flex shrink />
            <v-flex shrink>
              <!-- 新增 -->
              <v-btn
                v-if="
                  getPermission('SystemSettings.CustomerLevel.CreateOrEdit')
                "
                color="success"
                solid
                @click="handleAdd"
              >
                {{ $t("Views.Setting.add_button_label") }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
      </material-table>
    </helper-layout>
    <material-dialog
      :width="600"
      :visible="showDialog"
      :no-footer="false"
      :title="getDialogTitle"
      @cancleFn="handleDialogCancle"
      @confirmFn="handleDialogConfirm"
    >
      <span v-if="isDelete" class="desc">
        {{ $t("Views.Setting.confirm_dialog_delete_label") }}
      </span>
    </material-dialog>
  </div>
</template>

<script>
import { pageLoadMx } from '@/plugins/mixins.js'
import { mapState, mapActions } from 'vuex'
export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      headers: [
        {
          text: $t('Views.Setting.level_name_label'),
          value: 'name'
        },
        {
          text: $t('Views.Setting.desc_label'),
          value: 'description'
        },
        {
          text: $t('Views.Setting.action_label'),
          value: 'action',
          width: 200,
          actions: [
            {
              text: $t('Views.Customer.view'),
              color: 'success',
              visible: row => {
                return this.getPermission(
                  'SystemSettings.CustomerLevel'
                )
              },
              actionFn: row => {
                this.$router.push({
                  name: 'viewCustomerLevel',
                  query: {
                    id: row.row.id
                  }
                })
              }
            },
            {
              text: $t('Views.Setting.modify_label'),
              color: this.$store.state.app.editBtnColor,
              visible: row => {
                return this.getPermission(
                  'SystemSettings.CustomerLevel.CreateOrEdit'
                )
              },
              actionFn: row => {
                this.$router.push({
                  name: 'customerLevel_edit',
                  query: { id: row.row.id }
                })
              }
            },
            {
              text: $t('Views.Setting.delete_label'),
              color: this.$store.state.app.banBtnColor,
              visible: row => {
                return (
                  this.getPermission('SystemSettings.CustomerLevel.Delete') &&
                  !row.row.isStatic
                )
              },
              actionFn: row => {
                this.itemform = Object.assign({}, row.row)
                this.isDelete = true
                this.showDialog = true
              }
            }
          ]
        }
      ],
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        sorting: '',
        skipCount: 0,
        maxResultCount: 10
      },
      itemform: {
        name: '',
        description: ''
      },
      showDialog: false,
      /** false就是编辑或新增，true是删除 */
      isDelete: false
    }
  },
  computed: {
    ...mapState('setting', ['customerLevelData']),
    getDialogTitle() {
      return this.isDelete
        ? this.$t('Views.Setting.tip_label')
        : this.$t('Views.Setting.customer_level_label')
    },
    nameRules() {
      return [
        this.$util.rules.emptyRule(this.$t('Views.Setting.level_name_label'))
      ]
    }
  },
  mounted() {
    this.getPage()
  },
  methods: {
    ...mapActions('setting', [
      'getCustomerLevelList',
      'addOrEditCustomerLevelAction',
      'deleteCustomerLevelAction'
    ]),
    /** 获取是否有权限 */
    getPermission(name) {
      return this.$util.tool.hasPerm(name)
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }

      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getCustomerLevelList(this.form).then(() => {
        this.paginateConfig.total = this.customerLevelData.totalCount
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    /** 点击了新增按钮 */
    handleAdd() {
      this.$router.push({
        name: 'customerLevel_create'
      })
    },
    /** 弹窗取消按钮 */
    handleDialogCancle() {
      this.showDialog = false
    },
    /** 弹窗确定按钮 */
    handleDialogConfirm() {
      // 删除
      this.deleteCustomerLevelAction(this.itemform).then(res => {
        this.showDialog = false
        if (res.success === true) {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Setting.delete_customer_success_label'),
            type: 'success'
          })
          this.getPage()
        }
      })
    }
  }
}
</script>
<style scoped>
.require-mark {
  position: relative;
}
.require-mark::before {
  position: absolute;
  top: 0;
  left: -8px;
  content: "*";
  color: red;
}
.dialog-title {
  font-size: 14px;
  color: #515151;
  letter-spacing: 0;
  font-weight: bold;
}
.dialog-fix-input {
  margin-top: -15px;
}
</style>
